import type { Logger } from "@expert/logging";
import ky, { HTTPError } from "ky";
import { defaultHeaders, defaultTimeoutInMS } from "../types";
import type { DefaultPayload } from "./types";
import type { VerifyCustomerResult } from "./verifyCustomer";

type VerifyPasscodeForVerificationPayload = DefaultPayload & {
    mdn: string;
    passcode: string;
    transactionId: string;
};

export const verifyPasscodeForVerification = async (
    ssoAccessToken: string,
    payload: VerifyPasscodeForVerificationPayload,
    logger: Logger,
) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/api/device-activation/v1/verify-customer/verify-otp`;
        const resp = await ky.post(url, {
            headers: {
                ...defaultHeaders,
                Authorization: `Bearer ${ssoAccessToken}`,
            },
            json: payload,
            timeout: defaultTimeoutInMS,
        });

        const { accountMdns, activationFlowType, claimSummaries, token } = await resp.json<VerifyCustomerResult>();
        return { accountMdns, activationFlowType, claimSummaries, token };
    } catch (error) {
        logger.error({ error }, `Solve Guide | Error: Could not verify customer with passcode (OTP).`);

        let errorCode = "";
        let errorMessage = "";

        try {
            if (error instanceof HTTPError) {
                const errorJson = await error.response.json();
                errorCode = errorJson.code || "";
                errorMessage = errorJson.message || "";

                logger.info({ errorCode, errorMessage }, "Solve Guide | API returned error message");
            }
        } catch (parseError) {
            logger.error({ parseError }, "Solve Guide | Failed to parse error message");
        }

        return {
            accountMdns: [],
            activationFlowType: undefined,
            claimSummaries: [],
            token: undefined,
            errorCode,
            errorMessage,
        };
    }
};
